import React from 'react';

export interface ConfirmDialogModalProps {
  confirmDialog: { title: string; message: string; onConfirm: () => void } | null;
  setConfirmDialog: (val: null) => void;
}

export const ConfirmDialogModal: React.FC<ConfirmDialogModalProps> = ({
  confirmDialog,
  setConfirmDialog,
}) => {
  if (!confirmDialog) return null;

  return (
    <div className="fixed inset-0 z-[7000] bg-black/80 flex items-center justify-center p-4">
      <div className="bg-[#0a0e27] border border-red-500/50 rounded-xl p-6 w-full max-w-sm font-mono animate-in zoom-in-95 duration-200">
        <h3 className="text-sm font-bold mb-2 text-red-500 tracking-widest uppercase">{confirmDialog.title}</h3>
        <p className="text-xs text-white/70 mb-6">{confirmDialog.message}</p>
        <div className="flex gap-4">
          <button 
            onClick={() => confirmDialog.onConfirm()} 
            className="flex-1 bg-red-500 text-white font-bold py-2 rounded text-xs tracking-wider hover:bg-red-600 transition"
          >
            CONFIRMAR
          </button>
          <button 
            onClick={() => setConfirmDialog(null)} 
            className="flex-1 border border-white/30 text-white font-bold py-2 rounded text-xs tracking-wider hover:bg-white/10 transition"
          >
            CANCELAR
          </button>
        </div>
      </div>
    </div>
  );
};
